import { Component, OnInit } from '@angular/core';
import { UrlConstants } from 'src/app/models/urlConstants';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  hasTechnicalAnalysis: boolean = UrlConstants.hasTechnicalAnalysis;
  hasFundmentalAnalysis: boolean = UrlConstants.hasFundmentalAnalysis;
  
  constructor() { }

  ngOnInit(): void {
  }

}
